export default class ClearPostFormInputs {

    constructor() {
        this.settings = {
            $clearForm : $(".js-clear-post-form-inputs")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$clearForm.length) {
            const clearForm = document.querySelector('.js-clear-post-form-inputs');

            clearForm.addEventListener('click', () => {

                // Reset select inputs
                document.getElementById('blog_service').value = '';
                document.getElementById('blog_sector').value = '';
                document.getElementById('content_type').value = '';
                document.getElementById('blog_author').value = '';

                // Submit the form
                document.getElementById('category').submit();

            }); 
        }
    }
};

new ClearPostFormInputs();
